import React, {useMemo} from 'react'
import utils from 'helpers/utils';
import HydratePage from 'components/pages/Dev/Hydrate/HydratePage/HydratePage';
import HydrateBarWrapper from 'components/templates/Wrappers/Hydrate/HydrateBarWrapper/HydrateBarWrapper';

export default function useHydrateRoutes () {
  return useMemo(() => {
    const route = [
      {
        path: '',
        element: <HydratePage />,

        handle: {
          title: 'Hydrate',
          auth: utils.createAuth({attribute: 'dev.hydrate.capture'})
        }
      }
    ];

    return {
      WrapperComponent: HydrateBarWrapper,
      route: route
    };
  }, []);
};
